import { Button, Checkbox, Dropdown, Flex, ProviderConsumer as FluentUIThemeConsumer, Input, SearchIcon } from '@fluentui/react-northstar';
import React from 'react';
import { useTranslation } from 'react-i18next';
import GroupChatActivity from './components/GroupChatActivity';

interface ConversationToolbarActivityProps {
  isEndUserPage: boolean;
  groupChat: any;
  circleImage: any;
  groupChatText: string;
  loading: boolean;
  switchComment: boolean;
  properties: { key: string; header: string }[];
  filterIndex: number;
  searchQuery: string;
  isAutoFocused: boolean;
  setIsAutoFocused: (value: boolean) => void;
  onChangeHideHistory: (ev: React.SyntheticEvent<HTMLElement>) => void;
  onChangefilterIndex: (_event: any, props: any) => void;
  handleSearchClick: (_e: any) => void;
  onSearch: (e: any, v: any) => void;
}

const TicketConversationToolbarActivity: React.FC<ConversationToolbarActivityProps> = React.memo(({
  isEndUserPage, groupChat, circleImage, groupChatText, loading, switchComment,
  properties, filterIndex, searchQuery, isAutoFocused, setIsAutoFocused,
  onChangeHideHistory, onChangefilterIndex, handleSearchClick, onSearch
}) => {
  const { t } = useTranslation();
  return (
    <FluentUIThemeConsumer
      render={globalTheme => (
        <>
          {!isEndUserPage && (
            <>
              <div className='print-hidden'>
                {groupChat && (
                  <GroupChatActivity
                    groupChat={groupChat}
                    circleImage={circleImage}
                    groupChatText={groupChatText}
                    globalTheme={globalTheme}
                  />
                )}
              </div>
              <div style={{ margin: '0.75rem 0' }} className="flex justify-between print-hidden">
                <div className="hidden md:block">
                  <Flex.Item>
                    <Checkbox
                      disabled={loading}
                      label={t("ticket-details.ticket-conversation.only-comments")}
                      checked={switchComment}
                      onChange={onChangeHideHistory}
                      toggle />
                  </Flex.Item>
                </div>
                <Flex.Item>
                  <Flex gap="gap.smaller" className="md:w-2/3 w-full" style={{ height: 20, marginTop: 4 }}>
                    <div className="hidden md:block">
                      {!switchComment && (
                        <Dropdown
                          items={properties}
                          triggerButton={<span>{properties[filterIndex].header}</span>}
                          fluid
                          disabled={loading}
                          defaultActiveSelectedIndex={filterIndex}
                          onChange={onChangefilterIndex}
                          style={{
                            zIndex: 2,
                            marginTop: -5,
                            marginRight: 2,
                            marginLeft: -60,
                            width: '217px',
                            backgroundColor: globalTheme.siteVariables.colorScheme.default.background
                          }} />
                      )}
                    </div>
                    <Input
                      placeholder={t("ticket-details.ticket-conversation.search-placeholder")}
                      icon={<Button
                        text
                        content={<SearchIcon color="brand" />}
                        style={{ minWidth: 0, padding: 0 }}
                        onClick={handleSearchClick} />}
                      autoFocus={isAutoFocused}
                      onBlur={() => setIsAutoFocused(false)}
                      inverted
                      onChange={onSearch}
                      value={searchQuery}
                      fluid
                      style={{ marginTop: 1 }}
                      disabled={loading} />
                  </Flex>
                </Flex.Item>
              </div>
            </>
          )}
          {isEndUserPage && (
            <div>
              <div className='print-hidden'>
                {groupChat && (
                  <GroupChatActivity
                    groupChat={groupChat}
                    circleImage={circleImage}
                    groupChatText={groupChatText}
                    globalTheme={globalTheme}
                  />
                )}
              </div>
              <div style={{ margin: '0.75rem 0' }} className="flex justify-between print-hidden">
                <div className="hidden md:block">
                  <Flex.Item><></></Flex.Item>
                </div>
                <Flex.Item>
                  <Flex gap="gap.smaller" className="md:w-1/2 w-full" style={{ height: 20 }}>
                    <Input
                      placeholder={t("ticket-details.ticket-conversation.search-placeholder")}
                      icon={
                        <Button
                          text
                          content={<SearchIcon color="brand" />}
                          style={{ minWidth: 0, padding: 0 }}
                          onClick={handleSearchClick}
                        />
                      }
                      autoFocus={isAutoFocused}
                      inverted
                      onChange={onSearch}
                      value={searchQuery}
                      fluid
                      style={{ marginTop: 1 }}
                      disabled={loading}
                    />
                  </Flex>
                </Flex.Item>
              </div>
            </div>
          )}
        </>
      )} />
  );
});

export default TicketConversationToolbarActivity;